module.exports = __webpack_public_path__ + "img/gb.478d0d09.svg";